module.exports = __webpack_public_path__ + "img/point-4.5d72794d.jpg";